import {List} from 'immutable';

import {hasValue} from '@famly/stat_ts-utils_has-value';
import {serialize, deserialize} from 'web-app/react/components/file-upload/file-record';
import {createOfflineDrafter} from 'web-app/react/hooks/create-offline-drafter';

import {type State} from './hook-reducer';

export const OfflineDraftKey = 'OBSERVATION_EDITOR' as const;
const localStorageKeygen = () => OfflineDraftKey;

/**
 * Values passed to useOfflineDrafting must be JSON friendly, but `State` contains
 * and `Immutable.List` of files (`Immutable.Record`). We use encode and decode to
 * transform the values to and from JSON-able values.
 */
const encodeToLocalStorage = (state: State) => ({
    // For some reason TS ins't able to infer the ReturnType of this if I write it inline in createOfflineDrafter
    ...state,
    uploadedFiles: hasValue(state.uploadedFiles) ? state.uploadedFiles.toArray().map(serialize) : undefined,
});
export const {getOfflineValues, useOfflineDrafting, clearValues, hasOfflineValues} = createOfflineDrafter<State>()({
    keygen: localStorageKeygen,
    encode: encodeToLocalStorage,
    decode: offlineValues => ({
        ...offlineValues,
        uploadedFiles: hasValue(offlineValues.uploadedFiles)
            ? List(offlineValues.uploadedFiles).map(deserialize)
            : undefined,
    }),
});
